// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiHost: "",
  basicApiHost:"",
  // apiHost:'http://localhost:4200',
  tokenName: "backend-token",
  // username: "infobeans_user",
  // password: "cGochTh3W9EXpG6qUTyT",
  username: "",
  password: "",
  DATE_ADAPTOR: "DD-MMM-YYYY",
  SHOW_DATE_FORMAT: "dd-MMM-yyyy",
  SHOW_DATE_TIME_FORMAT: "dd-MMM-yyyy hh:mm:ss a",
  SHOW_TIME_FORMAT: "H:mm",
  SEND_DATE_FORMAT: "yyyy-MM-dd",
  AUTO_REFRESH: 5000,
  OUTPUT_ARR: ["pdf", "xls", "rtf", "txt"],
  category: {
    ems: "EMS",
    claims: "Claims",
  },
  KEY_VAR:"",
  IV_VAR:"",
  MODULE_ID: "",
  CONFIG_FILE_NAME:"evo-config",
  KEYS_FILE_NAME:"evo",
  RESET_PASS_CALLBACK_LINK:""

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
